var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mt-5",attrs:{"type":"error"}},[_vm._t("default"),_c('code',{staticClass:"code"},[_vm._v(_vm._s(_vm.errorMessage))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }